<template>
  <div>
    <v-snackbar absolute top :timeout="3000" v-model="snackbar">{{
      snackbarText
    }}</v-snackbar>
    <v-container fluid class="fill-height">
      <v-row class="pa-0 ma-0">
        <v-col cols="12" sm="12" md="12">
          <h1 class="page-title">Categorías</h1>
        </v-col>
      </v-row>

      <v-row class="mt-5">
        <v-col cols="12" sm="12" md="12">
          <search name="categorías" />
        </v-col>

        <v-col style="text-align: end" cols="12" sm="12" md="12">
          <v-btn
            color="btn-color"
            class="mt-3 mr-5"
            @click="showAddDialog"
            :loading="loading"
          >
            <v-icon left> fas fa-plus </v-icon>
            Agregar categoría
          </v-btn>
        </v-col>

        <v-col cols="12" sm="12" md="12">
          <files-table
            @menuClick="handleMenuActions($event)"
            :items="categories"
            :showList="true"
            :showEdit="true"
            :showDelete="true"
            :loading="loading"
            :headers="headers"
          />
        </v-col>

        <!-- <v-col
          v-if="!loading && filteredItems.length == 0"
          class="mt-10"
          style="text-align: center"
          cols="12"
          sm="12"
          md="12"
        >
          <span>Sin categorías agregados 😧</span>
        </v-col> -->

        <!-- <v-col
          cols="12"
          sm="3"
          md="3"
          v-for="(item, index) of filteredItems"
          :key="index"
        >
          <card
            @menuClick="handleMenuActions($event, item)"
            :name="item.name"
            :image="item.image ? item.image.original : ''"
            :items="menuItems"
          />
        </v-col> -->
      </v-row>
    </v-container>
    <!-- <v-fab-transition class="floating-btn">
      <v-btn
        @click="showAddDialog"
        color="primary"
        fab
        large
        :loading="loading"
        dark
        bottom
        right
      >
        <v-icon>fas fa-plus</v-icon>
      </v-btn>
    </v-fab-transition> -->

    <v-dialog v-if="addDialog" persistent max-width="70%" v-model="addDialog">
      <add-categories
        :originalItem="selectedItem"
        @success="added"
        @cancel="addDialog = false"
      />
    </v-dialog>

    <v-dialog
      v-if="viewImageDialog"
      persistent
      v-model="viewImageDialog"
      hide-overlay
      fullscreen
      max-width="60%"
    >
      <view-file
        :url="selectedItem.image.original"
        @success="added"
        type="image"
        @cancel="viewImageDialog = false"
      />
    </v-dialog>

    <v-dialog max-width="500px" v-if="deleteDialog" v-model="deleteDialog">
      <delete-item
        ref="deleteComponent"
        :name="selectedItem.name"
        @success="confirmDelete"
        @cancel="deleteDialog = false"
      />
    </v-dialog>

    <v-dialog
      v-if="subcategoriesDialog"
      persistent
      max-width="90%"
      v-model="subcategoriesDialog"
    >
      <subcategories
        :category="selectedItem"
        @success="added"
        @cancel="subcategoriesDialog = false"
      />
    </v-dialog>
  </div>
</template>
<script>
import { db, fb } from "@/firebase";
import addCategories from "./add-categories";
import deleteItem from "@/components/delete";
import subcategories from "./Subcategories/subcategories";
import filesTable from "@/components/files-table";
import viewFile from "@/components/view-file";

export default {
  name: "Categories",
  components: {
    addCategories,
    deleteItem,
    subcategories,
    filesTable,
    viewFile,
  },
  data() {
    return {
      categories: [],
      snackbarText: "",
      snackbar: false,
      loading: true,
      addDialog: false,
      subcategoriesDialog: false,
      selectedItem: null,
      deleteDialog: false,
      viewImageDialog: false,
      headers: [
        {
          value: "image",
          width: "150px",
        },
        {
          text: "Nombre",
          value: "name",
          width: "150px",
        },
        {
          text: "Descripción",
          value: "description",
          width: "150px",
        },
        {
          text: "Fecha de creación",
          value: "createdAt",
          width: "200px",
        },
        {
          value: "options",
          sortable: false,
          align: "end",
        },
      ],
      // menuItems: [
      //   { title: "Agregar subcategorías", icon: "fas fa-list" },
      //   { title: "Editar", icon: "fas fa-edit" },
      //   { title: "Eliminar", icon: "fas fa-trash" },
      // ],
    };
  },

  computed: {
    filteredItems() {
      let data = [];
      if (!this.$store.state.search) data = this.categories;
      else
        data = this.categories.filter((item) =>
          item.name
            .toLowerCase()
            .includes(this.$store.state.search.toLowerCase())
        );

      return data;
    },
  },
  methods: {
    sortedArray: function () {
      function compare(a, b) {
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;
        return 0;
      }
      return this.categories.sort(compare);
    },

    handleMenuActions(payload) {
      switch (payload.action) {
        case 0:
          this.viewImage(payload.item);
          break;
        case 1:
          this.edit(payload.item);
          break;
        case 2:
          this.showDeleteDialog(payload.item);
          break;
        case 3:
          this.viewSubcategories(payload.item);
          break;
      }
    },
    showAddDialog() {
      this.selectedItem = null;
      this.addDialog = true;
    },
    viewSubcategories(item) {
      this.selectedItem = item;
      this.subcategoriesDialog = true;
    },
    viewImage(item) {
      this.selectedItem = item;
      this.viewImageDialog = true
    },
    edit(item) {
      this.selectedItem = item;
      this.addDialog = true;
    },
    showDeleteDialog(item) {
      this.selectedItem = item;
      this.deleteDialog = true;
    },
    confirmDelete() {
      this.$refs.deleteComponent.loading = true;
      db.collection("categories")
        .doc(this.selectedItem[".key"])
        .delete()
        .then((response) => {
          this.snackbarText = "Categoría borrada exitosamente.";
          this.snackbar = true;
          this.$refs.deleteComponent.loading = false;
          this.deleteDialog = false;
        })
        .catch((error) => {
          this.snackbarText =
            "Ocurrió un error inesperado, inténtelo nuevamente.";
          this.snackbar = true;
          this.$refs.deleteComponent.loading = false;
        });
    },
    added() {
      this.addDialog = false;
      this.snackbarText = `Categoría ${
        this.selectedItem ? "editada" : "agregada"
      } exitosamente.`;
      this.snackbar = true;
    },
  },
  mounted() {
    let groupId = this.$store.state.groupId;
    db.collection("categories")
      .where("groupId", "==", groupId)
      .onSnapshot((response) => {
        this.categories = [];
        response.forEach((item) => {
          let category = item.data();
          category[".key"] = item.id;
          this.categories.push(category);
        });
        this.categories = this.sortedArray();
        this.loading = false;
      });
  },
};
</script>

<style>
.v-dialog--fullscreen {
  overflow-x: hidden !important;
}
</style>